import { PrintablePlayerSortName } from '@sorare/core/src/contexts/config';

export const SORTS: PrintablePlayerSortName[] = [
  'DESC-L15',
  'ASC-L15',
  'DESC-season_avg',
  'ASC-season_avg',
  'DESC-name_for_sorting',
  'ASC-name_for_sorting',
  'DESC-next_classic_fixture_projected_score',
  'ASC-next_classic_fixture_projected_score',
  'DESC-next_daily_fixture_projected_score',
  'ASC-next_daily_fixture_projected_score',
  'ASC-hitting_at_base',
  'DESC-hitting_at_base',
  'ASC-hitting_at_plate',
  'DESC-hitting_at_plate',
  'ASC-hitting_caught_stealing',
  'DESC-hitting_caught_stealing',
  'ASC-hitting_doubles',
  'DESC-hitting_doubles',
  'ASC-hitting_hit_by_pitch',
  'DESC-hitting_hit_by_pitch',
  'ASC-hitting_home_runs',
  'DESC-hitting_home_runs',
  'ASC-hitting_runs',
  'DESC-hitting_runs',
  'ASC-hitting_runs_batted_in',
  'DESC-hitting_runs_batted_in',
  'ASC-hitting_singles',
  'DESC-hitting_singles',
  'ASC-hitting_stolen_bases',
  'DESC-hitting_stolen_bases',
  'ASC-hitting_strikeouts',
  'DESC-hitting_strikeouts',
  'ASC-hitting_triples',
  'DESC-hitting_triples',
  'ASC-hitting_walks',
  'DESC-hitting_walks',
  'ASC-pitching_earned_runs',
  'DESC-pitching_earned_runs',
  'ASC-pitching_hits_allowed',
  'DESC-pitching_hits_allowed',
  'ASC-pitching_hit_batsmen',
  'DESC-pitching_hit_batsmen',
  'ASC-pitching_holds',
  'DESC-pitching_holds',
  'ASC-pitching_innings_pitched',
  'DESC-pitching_innings_pitched',
  'ASC-pitching_no_hitters',
  'DESC-pitching_no_hitters',
  'ASC-pitching_pitch_count',
  'DESC-pitching_pitch_count',
  'ASC-pitching_relief_appearance',
  'DESC-pitching_relief_appearance',
  'ASC-pitching_saves',
  'DESC-pitching_saves',
  'ASC-pitching_strikeouts',
  'DESC-pitching_strikeouts',
  'ASC-pitching_walks',
  'DESC-pitching_walks',
  'ASC-pitching_wins',
  'DESC-pitching_wins',
];
